import { ThemeProvider } from "styled-components";
import { GlobalStyle, lightTheme } from "./styles/theme";
import { LayoutWrapper } from "./components/LayoutWrapper";
import { ProfileHeader } from "./components/ProfileHeader";
import { LinkButton } from "./components/LinkButton";
import { SocialIcons } from "./components/SocialIcons";
import { links } from "./data/links";
import { ButtonGroup } from "./components/ButtonGroup";

const App = () => {
  return (
    <ThemeProvider theme={lightTheme}>
      <GlobalStyle />
      <LayoutWrapper>
        <ProfileHeader />

        <ButtonGroup>
          {links.map((link, index) => (
            <LinkButton key={index} {...link} />
          ))}
        </ButtonGroup>

        <SocialIcons />
      </LayoutWrapper>
    </ThemeProvider>
  );
};

export default App;
